import videojs from 'video.js';

let initialized = false;

export const initVideojsI18n = () => {
  if (initialized) return;

  videojs.addLanguage('zh-CN', {
    Play: '播放',
    Pause: '暂停',
    Replay: '重播',
    'Current Time': '当前时间',
    Duration: '时长',
    'Remaining Time': '剩余时间',
    Fullscreen: '全屏',
    'Non-Fullscreen': '退出全屏',
    Mute: '静音',
    Unmute: '取消静音',
    'Playback Rate': '播放速度',
    Subtitles: '字幕',
    Captions: '字幕',
    'Picture-in-Picture': '画中画',
  });

  videojs.addLanguage('de', {
    Play: 'Wiedergabe',
    Pause: 'Pause',
    Replay: 'Erneut abspielen',
    'Current Time': 'Aktuelle Zeit',
    Duration: 'Dauer',
    'Remaining Time': 'Verbleibende Zeit',
    Fullscreen: 'Vollbild',
    'Non-Fullscreen': 'Vollbild beenden',
    Mute: 'Stummschalten',
    Unmute: 'Stummschaltung aufheben',
    'Playback Rate': 'Wiedergabegeschwindigkeit',
    Subtitles: 'Untertitel',
    Captions: 'Untertitel',
    'Picture-in-Picture': 'Bild-in-Bild',
  });

  videojs.addLanguage('nl', {
    Play: 'Afspelen',
    Pause: 'Pauzeren',
    Replay: 'Opnieuw afspelen',
    'Current Time': 'Huidige tijd',
    Duration: 'Duur',
    'Remaining Time': 'Resterende tijd',
    Fullscreen: 'Volledig scherm',
    'Non-Fullscreen': 'Volledig scherm sluiten',
    Mute: 'Dempen',
    Unmute: 'Dempen opheffen',
    'Playback Rate': 'Afspeelsnelheid',
    Subtitles: 'Ondertitels',
    Captions: 'Ondertitels',
    'Picture-in-Picture': 'Beeld-in-beeld',
  });

  videojs.addLanguage('it', {
    Play: 'Riproduci',
    Pause: 'Pausa',
    Replay: 'Riproduci di nuovo',
    'Current Time': 'Tempo corrente',
    Duration: 'Durata',
    'Remaining Time': 'Tempo rimanente',
    Fullscreen: 'Schermo intero',
    'Non-Fullscreen': 'Esci da schermo intero',
    Mute: 'Disattiva audio',
    Unmute: 'Attiva audio',
    'Playback Rate': 'Velocità di riproduzione',
    Subtitles: 'Sottotitoli',
    Captions: 'Sottotitoli',
    'Picture-in-Picture': 'Picture-in-picture',
  });

  videojs.addLanguage('fr', {
    Play: 'Lire',
    Pause: 'Pause',
    Replay: 'Relire',
    'Current Time': 'Temps actuel',
    Duration: 'Durée',
    'Remaining Time': 'Temps restant',
    Fullscreen: 'Plein écran',
    'Non-Fullscreen': 'Quitter le plein écran',
    Mute: 'Muet',
    Unmute: 'Activer le son',
    'Playback Rate': 'Vitesse de lecture',
    Subtitles: 'Sous-titres',
    Captions: 'Sous-titres',
    'Picture-in-Picture': 'Image dans l’image',
  });

  videojs.addLanguage('es', {
    Play: 'Reproducir',
    Pause: 'Pausa',
    Replay: 'Reproducir de nuevo',
    'Current Time': 'Tiempo actual',
    Duration: 'Duración',
    'Remaining Time': 'Tiempo restante',
    Fullscreen: 'Pantalla completa',
    'Non-Fullscreen': 'Salir de pantalla completa',
    Mute: 'Silenciar',
    Unmute: 'Activar sonido',
    'Playback Rate': 'Velocidad de reproducción',
    Subtitles: 'Subtítulos',
    Captions: 'Subtítulos',
    'Picture-in-Picture': 'Imagen en imagen',
  });

  videojs.addLanguage('cs', {
    Play: 'Přehrát',
    Pause: 'Pozastavit',
    Replay: 'Přehrát znovu',
    'Current Time': 'Aktuální čas',
    Duration: 'Délka',
    'Remaining Time': 'Zbývající čas',
    Fullscreen: 'Celá obrazovka',
    'Non-Fullscreen': 'Ukončit celou obrazovku',
    Mute: 'Ztlumit',
    Unmute: 'Zapnout zvuk',
    'Playback Rate': 'Rychlost přehrávání',
    Subtitles: 'Titulky',
    Captions: 'Titulky',
    'Picture-in-Picture': 'Obraz v obraze',
  });

  videojs.addLanguage('pl', {
    Play: 'Odtwórz',
    Pause: 'Pauza',
    Replay: 'Odtwórz ponownie',
    'Current Time': 'Aktualny czas',
    Duration: 'Czas trwania',
    'Remaining Time': 'Pozostały czas',
    Fullscreen: 'Pełny ekran',
    'Non-Fullscreen': 'Zamknij pełny ekran',
    Mute: 'Wycisz',
    Unmute: 'Włącz dźwięk',
    'Playback Rate': 'Prędkość odtwarzania',
    Subtitles: 'Napisy',
    Captions: 'Napisy',
    'Picture-in-Picture': 'Obraz w obrazie',
  });

  initialized = true;
};
